(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('underscore'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_) {
  'use strict';

  /**
   * Route related utility methods
   *
   * @class routerUtils
   * @static
   */
  var routerUtils = {
    /**
     * Parses query string parameters into an object. 'var1=1&var2=2' -> {var1:1, var2:2}
     * @param queryParamString to parse
     * @return {Object} query params as an object with each param as a property on the object
     */
    parseQueryString: function (queryParamString) {
      var queryStringParams = queryParamString && queryParamString.split('&');
      var nonEmptyQueryStringParams = _.filter(queryStringParams);
      var queryStringParamObjectArray = _.map(nonEmptyQueryStringParams, this.parseQueryStringParam);
      return _.reduce(queryStringParamObjectArray, this.updateQueryObjectFromParam, {});
    },

    /**
     * Update the queryObject with the parameter key/value pair and take into account multiple occurances of a
     * query param key means it is an array of values.
     *
     * @param queryObject {Object} the queryObject holding the result of the parsing.
     * @param queryParamArray {Object[]} where the first item is the query param name, and the 2nd is the value.
     * @return {Object} the updated queryObject.
     */
    updateQueryObjectFromParam: function(queryObject, queryParamArray) {
      var queryParamKey = queryParamArray[0];
      var queryParamValue = queryParamArray[1];
      var existingQueryParamValue = queryObject[queryParamKey];
      if (!existingQueryParamValue) {
        queryObject[queryParamKey] = queryParamValue;
      } else if (_.isArray(existingQueryParamValue)) {
        existingQueryParamValue.push(queryParamValue);
      } else {
        queryObject[queryParamKey] = [ existingQueryParamValue, queryParamValue ];
      }
      return queryObject;
    },

    /**
     * Parses one parameter of a query string into a url decoded array of name and value.
     * 'var1=1' -> [ 'var1' : '1' ].
     * @param queryStringParam {String} the individual parameter to parse.
     * @return {String[]} an array containing non-empty, url-decoded parameter names and url-decoded parameter value.
     *                    If the parameter name is empty then undefined is returned.
     */
    parseQueryStringParam: function(queryStringParam) {
      var queryStringParamParts = queryStringParam.split('=');
      var decodedQueryStringParamParts = _.map(queryStringParamParts, decodeURIComponent);
      var queryStringParamName = decodedQueryStringParamParts[0];
      if (queryStringParamName) {
        return decodedQueryStringParamParts;
      }
    },

    /**
     * Pulled from http://stackoverflow.com/a/11654596 and cleaned up.
     * Takes the current hash and adds the given query parameter to it and then updates the current hash to the new one.
     * @method updateQueryString
     * @param key {String} the query parameter name.
     * @param value {String} the query parameter value.
     * @param [hash=window.location.hash] {String} the hash to update the query string on.  Uses the current page hash if not set.
     */
    updateHashQueryString: function(key, value, hash) {
      hash = hash || window.location.hash;
      hash = routerUtils.addQueryParameterToHash(key, value, hash);
      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    },

    /**
     * Pulled from http://stackoverflow.com/a/11654596 and cleaned up.
     * Takes the current hash and adds the given query parameter to it and then updates the current hash to the new one.
     * @method addQueryParameterToHash
     * @param key {String} the query parameter name.
     * @param value {String} the query parameter value.
     * @param hash {String} the hash to update the query string on.  Will fail if not set.
     * @return {String} the hash updated with the query values.
     */
    addQueryParameterToHash: function(key, value, hash) {
      var encodedKey = key && encodeURIComponent(key);
      var encodedValue = value && encodeURIComponent(value);
      var queryStringRegex = new RegExp('([?&])' + encodedKey + '=.*?(&|$)(.*)', 'gi');
      var isRemovingValue = _.isEmpty(value);
      var isUpdateToExistingValueInHash = queryStringRegex.test(hash);

      if (isUpdateToExistingValueInHash) {
        if (isRemovingValue) {
          hash = hash.replace(queryStringRegex, '$1$3').replace(/(&|\?)$/, '');
        } else {
          hash = hash.replace(queryStringRegex, '$1' + encodedKey + '=' + encodedValue + '$2$3');
        }
      } else if (!isRemovingValue) {
        var separator = hash.indexOf('?') !== -1 ? '&' : '?';
        hash += separator + encodedKey + '=' + encodedValue;
      }
      return hash;
    },

    /**
     * Clean URL so that it cannot redirect to other domains. Only relative redirects are allowed.
     * @param url valid
     * @returns {String} cleaned url
     */
    cleanRedirectURL: function(url) {
      // clean out unusual characters: http://stackoverflow.com/a/205967
      url = url.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;\\(\\)]/, '');
      //  relative url - safe
      if (/^[^\s:\/]+$/.test(url)) {
        return url;
      }
      // Only allow urls with the current domain
      var currentDomain = 'https://' + window.location.host;
      //  Add the current server & prototcol for urls starting with /:
      url = url.replace(/^(\/)/, currentDomain + '/');
      // Do not allow urls unless they are https (prevents XSS in url - javascript:alert('XSS FAIL'))
      // allow port 8443 for non dockerized environemnts
      if (!/^(?:https:)(?:\/\/\S+:8443)?[^\s:]+$/.test(url)) {
        url = '';
      }
      // Do not allow anything from a different host.
      if (url.substring(0, currentDomain.length) !== currentDomain) {
        url = '';
      }
      return url;
    }
  };

  return routerUtils;
}));
